export default __webpack_public_path__ + "static/media/Nairobi.22086168.png";